import React, { lazy } from 'react';

import {
  AutoModalPriority,
  useAutoModal,
} from '../../../common/AutoModalProvider';
import { useJobSlotUpgradedModal } from './useJobSlotUpgradedModal';

const JobSlotUpgradedModal = lazy(() => import('./JobSlotUpgradedModal'));

export default function RenderJobSlotUpgradedModal() {
  const modalData = useJobSlotUpgradedModal();
  const canShow = useAutoModal(AutoModalPriority.Status, Boolean(modalData));

  if (!modalData || !canShow) return null;

  const { newTotalJobSlots, markSeen } = modalData;

  return (
    <JobSlotUpgradedModal newLimit={newTotalJobSlots} onClose={markSeen} />
  );
}
